import React from 'react';
import InputBox from '../../components/InputBox'

class PasswordBox extends React.Component {
    
    // Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }

    validate = () => {
        const password = this._input.getValue();

        // We don't validate empty values
        if (password === "") { 
            this.flag(true); 
            return null; 
        } 

        // Validate password shape
        if (password.length < 8 || password.length > 256)
            return "Your password must contain between 8 and 256 characters.";

        if (!/\d/.test(password))
            return "Your password must contain at least one numeric value.";

        if (!/[A-Z]/.test(password))
            return "Your password must contain at least one alphabetic character capitalized.";

        if (!/[!@#$%&*()_\-+=]/.test(password))
            return "Your password must contain at least one special character."

        return null;
    }
    
	completed = () => {
		return this._input.completed();
	}

    // React
    render() {
        const props = {
            type: "password",
            maxLength: 270,
			...this.props
		}

		return (<InputBox {...props} ref={(input) => this._input = input} />)
    }
}

export default PasswordBox;

// Mark this as a form component
PasswordBox.defaultProps = {
	formControl: true,
	managed: false
};



// WEBPACK FOOTER //
// ./src/fw/forms/controls/passwordBox/PasswordBox.js